import React from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from './config';

/**
 * I18nProvider - Provides i18n context to the entire application
 *
 * This component wraps the application and makes i18n available to all child components
 * via react-i18next hooks like useTranslation()
 */
export const I18nProvider = ({ children }) => {
  return (
    <I18nextProvider i18n={i18n}>
      {children}
    </I18nextProvider>
  );
};

export default I18nProvider;
